import { isPrivateView } from '@/common/components/FilterViews/helpers'

export const getFixedGroupIds = (ownGroupIds, view) => {
  if (isPrivateView(view)) return ownGroupIds

  return ownGroupIds.filter(groupId => view.shared_with_groups.includes(groupId))
}

export const getInitialSelectedGroupIds = (view, fixedGroupIds) => {
  return isPrivateView(view) ? fixedGroupIds : view.shared_with_groups
}

export const haveSameGroupIds = (groupIds, otherGroupIds) => {
  return groupIds.length === otherGroupIds.length && groupIds.every(groupId => otherGroupIds.includes(groupId))
}
